import { render } from "./MegastoreView.vue?vue&type=template&id=7ef4a1c8"
import script from "./MegastoreView.vue?vue&type=script&lang=js"
export * from "./MegastoreView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__